import { ServiceProvider } from "@RequestFormV2/sections/Service/context";
import ServiceLevelSection from "@RequestFormV2/sections/Service/components/ServiceLevelSection";
import RequirementsSection from "@RequestFormV2/sections/Service/components/RequirementsSection";
import "./Service.scss";

export default function QuickService() {
  return (
    <ServiceProvider>
      <ServiceLevelSection />
      <RequirementsSection />
    </ServiceProvider>
  );
}
